var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{attrs:{"color":_vm.themeColor}},[_c('v-card-title',{staticClass:"text-h5 text-xl-h2 text-lg-h3 text-sm-h4 py-4 py-md-5 py-lg-7 py-xl-8 pl-3 pl-sm-6"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-text',{staticClass:"card-content neutral--text px-3 px-sm-6"},[_c('span',{staticClass:"card-content-border",style:({
          'background-color': _vm.themeColor
        })}),_c('v-row',{staticClass:"py-6"},[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }